// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8MWIf","badges":"styles_badges__25eNL"};